import { Typography, TypographyProps } from 'omakase';
import { legendListDefinition, legendListItem, legendListItemIcon } from './legendListCssDefs';
import React from 'react';

interface LegendListItemProps {
  /**
   * list item icon
   */
  icon: React.ReactNode;
  /**
   * list item label
   */
  children: React.ReactNode;
  /**
   * list item description
   */
  description?: React.ReactNode;
  /**
   * color applied to body text and icon
   */
  color?: TypographyProps['color'];
}

/**
 * A single item in a LegendList. Controls the layout of an icon
 * and font display of the description text.
 */
export const LegendListItem: React.FC<React.PropsWithChildren<LegendListItemProps>> = ({
  icon,
  children,
  description,
  color,
}) => {
  return (
    <div css={legendListItem}>
      <Typography component="dt" css={legendListItemIcon} color={color}>
        {icon}
      </Typography>
      <dd css={legendListDefinition}>
        <Typography mb={description ? 0.25 : 0} color={color}>
          {children}
        </Typography>
        {description && (
          <Typography variant="caption" color={color ?? 'fgSubtle'}>
            {description}
          </Typography>
        )}
      </dd>
    </div>
  );
};
